var modals = [].slice.call(document.querySelectorAll('div[role="dialog"]:not(.gm-style-iw)')),
	mainModal = document.getElementById('modal');

modals.forEach(function(modal) {
	modal.addEventListener('click', function(e) {
		if(e.target == modal.querySelector('.close-modal') || !modal.querySelector('.content').contains(e.target))
			closeModal();
	});
});

function closeModal() {
	modals.forEach(function(modal) {
		if(window.getComputedStyle(modal).display == 'block')
			Velocity(modal, {opacity: [0,1]}, {duration: 300, display: 'none'});

		if(modal == mainModal) {
			Cookie.set('popup-closed', 'closed');
		} else if(modal == videoModal) {
			setTimeout(function() {
				videoIframe.src = 'about:blank';
				skipLinkToggleDisplay(false);
				setFocus(false, false);

				if(videoModalButton)
					videoModalButton.focus();
			}, 300);
		}
	});
}

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		closeModal();
});

if(mainModal) {
	setTimeout(function() {
		Velocity(mainModal, {opacity: [1,0]}, {duration: 300, display: 'block'});
		mainModal.querySelector('.close-modal').focus();
		skipLinkToggleDisplay(true);
		setFocus(true, false);
	}, 10000);
}